// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TenantSiteSiteSearchSiteSearchResponse {
    static getAttributeTypeMap() {
        return TenantSiteSiteSearchSiteSearchResponse.attributeTypeMap;
    }
}
TenantSiteSiteSearchSiteSearchResponse.discriminator = undefined;
TenantSiteSiteSearchSiteSearchResponse.additionalProperties = false;
TenantSiteSiteSearchSiteSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "TenantSiteSiteSearchSiteSearchResponseData"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=tenantSiteSiteSearchSiteSearchResponse.js.map